module.exports = __webpack_public_path__ + "img/pocket_bag_width.eaf328fa.png";